export class WarrantyExpirationDto {
    deviceName: string;
    warrantyExpiration: string;

    constructor(values : string[]) {
        this.deviceName = values[0];
        this.warrantyExpiration = values[1];
    }
}